/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { Container, Row, Col, Card } from 'react-bootstrap';
import { JsonEditor } from 'json-edit-react';

function ProbeDetailCode({ data } : { data: any }) {
  const detail = data.detail;
  
  // Format the code result for display
  const codeResult = detail.code_result || "No result returned";
  
  // If the result is an object or array, we'll use JsonEditor to display it
  // Otherwise, we'll just display it as text
  const isJsonResult = typeof codeResult === 'object' || 
                       (typeof codeResult === 'string' && 
                       (codeResult.startsWith('{') || codeResult.startsWith('[')));
  
  const getDisplayContent = () => {
    if (isJsonResult) {
      try {
        const jsonData = typeof codeResult === 'string' ? JSON.parse(codeResult) : codeResult;
        return (
          <JsonEditor
            data={jsonData}
            onUpdate={({ newData }) => {
              console.log('Updated data:', newData);
            }}
          />
        );
      } catch (e) {
        return <pre className="bg-light p-3 rounded">{codeResult}</pre>;
      }
    } else {
      return <pre className="bg-light p-3 rounded">{codeResult}</pre>;
    }
  };

  return (
    <Container fluid>
      <Row className="mb-4">
        <Col>
          <h3>Code Execution Result</h3>
        </Col>
      </Row>
      { data.pending === 0 &&
        <Row className="me-4">
            <Col>
            <Card>
                <Card.Header>
                <strong>Result</strong>
                </Card.Header>
                <Card.Body>
                {getDisplayContent()}
                </Card.Body>
            </Card>
            </Col>
        </Row>
      }
      <Row className="me-4 mt-4">
        <Col>
          <Card>
            <Card.Header>
              <strong>Code</strong>
            </Card.Header>
            <Card.Body>
              <pre className="bg-light p-3 rounded">{detail.code}</pre>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ProbeDetailCode;